import request from "@/utils/request";
import { IMidEvidence } from "../model/midevidence";

// 实体
export const defaultMidEvidenceData: IMidEvidence = {
  id: "",
  appId: "",
  businessId: "",
  behaviorId: "",
  subjectId: "",
  behaviorObjectSubjectId: "",
  rid: "",
  serviceId: "",
  requestTime: 0,
  sn: "",
  ip: "",
  ts: 0,
  ctsr: "",
  txHash: "",
  transStatus: 0,
  createTime: 0,
  serviceData: "",
  messageDigest: "",
  privateKeySign: "",
  beforeCount: 0,
  afterCount: 0,
  blockNumber: 0,
  serviceDataTemp: "",
  description: "",
  docUrl: "",
  hasDoc: false
};

export const getMidEvidence = (id: any) => {
  request({
    url: "/MidEvidence/Get",
    method: "post",
    params: { id: id }
  });
};

export const addMidEvidence = (data: any) =>
  request({
    url: "/MidEvidence/Add",
    method: "post",
    data
  });

export const updateMidEvidence = (data: any) =>
  request({
    url: "/MidEvidence/Update",
    method: "post",
    data
  });

export const deleteMidEvidence = (id: string) =>
  request({
    url: "/MidEvidence/Delete",
    method: "post",
    params: { id: id }
  });

export const getMidEvidencePageList = (data: any) =>
  request({
    url: "/MidEvidence/GetPageListAsync",
    method: "post",
    data
  });

export const getListByServiceId = (serviceId: string) =>
  request({
    url: "/MidEvidence/GetListByServiceId",
    method: "post",
    params: { serviceId: serviceId }
  });

export const getMessageDigest = (encryptInfo: string, behaviorId: string) =>
  request({
    url: "/MidEvidence/GetMessageDigest",
    method: "post",
    params: {
      encryptInfo: encryptInfo,
      behaviorId: behaviorId
    }
  });

export const upperChain = (data: any) =>
  request({
    url: "/MidEvidence/UpperChain",
    method: "post",
    data
  });

export const reUpperChain = (eviUpperchainId: string) =>
  request({
    url: "/MidEvidence/ReUpperChain",
    method: "post",
    params: { eviUpperchainId: eviUpperchainId }
  });

export const collect = (eviUpperchainId: string) =>
  request({
    url: "/MidEvidence/Collect",
    method: "post",
    params: { eviUpperchainId: eviUpperchainId }
  });

export const docGenerate = (serviceId: string) =>
  request({
    url: "/MidEvidence/PdfGenerate",
    method: "post",
    params: { serviceId: serviceId },
    isLoading: true
  });

export const chanVerify = (serviceId: string) =>
  request({
    url: "/MidEvidence/ChanVerify",
    method: "post",
    params: { serviceId: serviceId }
  });

export const generateServiceId = (appId: string) =>
  request({
    url: "/MidEvidence/GenerateServiceId",
    method: "post",
    params: { appId: appId }
  });
